const drawers = {
  circle({
    cx, cy, r, fill, stroke, strokeWidth, backGround,
  }) {
    this.beginPath();
    this.arc(cx, cy, r, 0, 2 * Math.PI, false);
    if (backGround) {
      this.fillStyle = backGround;
      this.fill();
    }
    if (fill) {
      this.fillStyle = fill;
      this.fill();
    }
    this.lineWidth = strokeWidth;
    this.strokeStyle = stroke;
    this.stroke();
  },
  line({
    x1, y1, x2, y2, stroke, strokeWidth, strokeDashArray,
  }) {
    this.strokeStyle = stroke;
    this.lineWidth = strokeWidth;
    this.beginPath();
    if (strokeDashArray) {
      this.setLineDash(strokeDashArray);
    }
    this.moveTo(x1, y1);
    this.lineTo(x2, y2);
    this.stroke();
  },
  text({
    text, x, y, fill, textBaseline, textAlign, font,
  }) {
    this.fillStyle = fill;
    this.textBaseline = textBaseline;
    this.textAlign = textAlign;
    this.font = font;
    this.fillText(text, x, y);
  },
  canvasFill({ fill, width, height }) {
    this.clearRect(0, 0, width, height);
    this.fillStyle = fill;
    this.fillRect(0, 0, width, height);
  },
  rect({
    x, y, width, height, fill, strokeWidth, stroke,
  }) {
    this.fillStyle = fill;
    this.lineWidth = strokeWidth;
    this.strokeStyle = stroke;
    this.fillRect(x, y, width, height);
    this.strokeRect(x, y, width, height);
  },
  roundRect({
    x, y, width, height, fill, strokeWidth, stroke, radii, backGround,
  }) {
    this.strokeStyle = stroke;
    this.lineWidth = strokeWidth;
    this.beginPath();
    if (this.roundRect) {
      this.roundRect(x, y, width, height, radii);
    } else {
      this.rect(x, y, width, height);
    }
    if (backGround) {
      this.fillStyle = backGround;
      this.fill();
    }
    this.fillStyle = fill;
    this.fill();
    this.stroke();
  },
  arrow({
    x1, y1, x2, y2, arrowWidth, stroke, strokeDashArray,
  }) {
    // variables to be used when creating the arrow
    const headlen = 10;
    const angle = Math.atan2(y2 - y1, x2 - x1);

    this.save();
    this.strokeStyle = stroke;

    // starting path of the arrow from the start square to the end square
    // and drawing the stroke
    this.save();
    this.beginPath();
    if (strokeDashArray) {
      this.setLineDash(strokeDashArray);
    }
    this.moveTo(x1, y1);
    this.lineTo(x2, y2);
    this.lineWidth = arrowWidth;
    this.stroke();
    this.restore();

    // starting a new path from the head of the arrow to one of the sides of
    // the point
    this.beginPath();
    this.moveTo(x2, y2);
    this.lineTo(
      x2 - headlen * Math.cos(angle - Math.PI / 7),
      y2 - headlen * Math.sin(angle - Math.PI / 7),
    );

    // path from the side point of the arrow, to the other side point
    this.lineTo(
      x2 - headlen * Math.cos(angle + Math.PI / 7),
      y2 - headlen * Math.sin(angle + Math.PI / 7),
    );

    // path from the side point back to the tip of the arrow, and then
    // again to the opposite side point
    this.lineTo(x2, y2);
    this.lineTo(
      x2 - headlen * Math.cos(angle - Math.PI / 7),
      y2 - headlen * Math.sin(angle - Math.PI / 7),
    );
    this.closePath();
    this.fillStyle = stroke;
    // draws the paths created above
    this.fill();
    this.stroke();
    this.restore();
  },
  path2d({ path, strokeWidth, translate }) {
    if (this !== null) {
      this.strokeWidth = strokeWidth;
      if (translate) {
        const { x, y } = translate;
        this.translate(x, y);
      }
      this.stroke(path);
    }
  },
  arc({
    cx, cy, r, fill, stroke, strokewidth, backGround, startAngle, endAngle, direaction,
  }) {
    this.beginPath();
    this.arc(cx, cy, r, startAngle, endAngle, direaction);
    if (backGround) {
      this.fillStyle = backGround;
      this.fill();
    }
    if (fill) {
      this.fillStyle = fill;
      this.fill();
    }
    if (stroke) {
      this.lineWidth = strokewidth;
      this.strokeStyle = stroke;
      this.stroke();
    }
  },
  cross({
    cx, cy, r, stroke, strokeWidth,
  }) {
    this.lineWidth = strokeWidth;
    this.strokeStyle = stroke;
    this.beginPath();
    this.moveTo(cx - r, cy);
    this.lineTo(cx + r, cy);
    this.moveTo(cx, cy - r);
    this.lineTo(cx, cy + r);
    this.stroke();
  },
};
export default drawers;
